<template>
  <div class="contentDetails">
    <NavBar :navBlock='navBlock' :navtitle='navtitle' :pageBack='true'></NavBar>
      <div class="detailsContent">
        <Photo :type='type'></Photo>
      </div>
  </div>
</template>

<script>
import NavBar from '@/components/navBar'
import Photo from '@/components/Photo';
export default {
  data () {
    return {
      navBlock:'新聞  /  私密相簿',
      navtitle:'新增相簿',
      type: 'add'
    }
  },
  created(){
  },
  methods:{
  },
  components: {
    NavBar,
    Photo
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/news/photoPrivacy/addPhoto.vue